import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Revenue from '@/internal/pages/Revenue';
import Error404 from '@/Error404';

const Routes = ({match}) => (
  <Switch>
    <Route
      path={match.path}
      exact
      component={() => {
        window.location.href = process.env.REACT_APP_AMOEBA_URL;
        return null;
      }}
    />
    <Route path={`${match.path}/revenues/:id`} component={Revenue} />
    <Route component={Error404} />
  </Switch>
);

export default Routes;
